/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

import { letterSpacing } from "@mui/system";

export default function themeTypography(theme) {
    return {
        fontFamily: theme?.customization?.fontFamily,
        paragraph: {
            display: 'block',
            fontWeight: 400,
            color: theme.heading,
            fontSize: '1rem',
            lineHeight: '1.5rem',
            marginBottom: '1rem'
        },
        a: {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
        h6: {
            fontWeight: 500,
            color: theme.heading,
            fontSize: '0.75rem'
        },
        h5: {
            fontSize: '0.875rem',
            color: theme.heading,
            fontWeight: 500
        },
        h4: {
            fontSize: '1rem',
            color: theme.heading,
            fontWeight: 600
        },
        h3: {
            fontSize: '1.25rem',
            lineHeight: '1.25rem',
            color: theme.heading,
            fontWeight: 300,
        },
        h2: {
            fontSize: '28px',
            color: theme.heading,
            fontWeight: 400
        },
        h1: {
            fontSize: '2.25rem',
            color: theme.heading,
            fontWeight: 700
        },
        subtitle1: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: theme?.customization?.navType === 'dark' ? theme.heading : theme.textDark
        },
        subtitle2: {
            fontSize: '0.75rem',
            fontWeight: 400,
            color: theme.darkTextSecondary
        },
        button: {
            textTransform: 'none'
        },
        caption: {
            fontSize: '0.75rem',
            color: theme.darkTextSecondary,
            fontWeight: 400
        },
        // body1: {
        //     fontSize: '0.875rem',
        //     fontWeight: 400,
        //     lineHeight: '1.334em'
        // },
        body1: {
            fontSize: '1rem',
            fontWeight: 350,
            lineHeight: '1.5em',
            
            letterSpacing: '-.3px'
        },
        
        body2: {
            letterSpacing: '0em',
            fontWeight: 400,
            lineHeight: '1.5em',
            color: theme.darkTextPrimary
        },
        bannerParagraph: {
            display: 'block',
            padding: '25px 0',
            fontSize: '1.4rem',
            lineHeight: '1.6rem',
            fontWeight: 400
        },
        bold: {
            fontWeight: 700
        },
        small: {
            fontSize: 14
        },
        extraSmall: {
            fontSize: 12,
        },
        customFloatingLabelInput: {
            marginTop: 2,
            marginBottom: 1,
            '& > label': {
                top: 23,
                left: 0,
                color: theme.grey500,
                '&[data-shrink="false"]': {
                    top: 5
                }
            },
            '& > div > input': {
                padding: '11.5px 14px 11.5px !important'
            },
            '& fieldset': {
                top: 0
            }
        },        
        customInput: {
            marginTop: 1,
            marginBottom: 1,
            '& > label': {
                top: 23,
                left: 0,
                color: theme.grey500,
                '&[data-shrink="false"]': {
                    top: 5
                }
            },
            '& > div > input': {
                padding: '11.5px 14px 11.5px !important'
            },
            '& legend': {
                display: 'none'
            },
            '& fieldset': {
                top: 0
            }
        },
        mainContent: {
            backgroundColor: theme.background,
            width: '100%',
            minHeight: 'calc(100vh - 88px)',
            flexGrow: 1,
            borderRadius: `${theme?.customization?.borderRadius}px`
        },
        menuCaption: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: theme.heading,
            padding: '6px',
            marginTop: '10px'
        },
        subMenuCaption: {
            fontSize: '0.6875rem',
            fontWeight: 500,
            color: theme.darkTextSecondary,
        },
        commonAvatar: {
            cursor: 'pointer',
            borderRadius: '8px'
        },
        smallAvatar: {
            width: '22px',
            height: '22px',
            fontSize: '1rem'
        },
        mediumAvatar: {
            width: '34px',
            height: '34px',
            fontSize: '1.2rem'
        },
        largeAvatar: {
            width: '44px',
            height: '44px',
            fontSize: '1.5rem'
        }
    };
}
